module.exports = __webpack_public_path__ + "static/media/picHeight.855334b0.jpg";